export interface MapEventSubscription {
  unsubscribe(): void;
}

export class MapEventSubscriptions {
  private subscriptions: MapEventSubscription[] = [];

  track(subscription: MapEventSubscription): void {
    this.subscriptions.push(subscription);
  }

  clear(): void {
    while (this.subscriptions.length > 0) {
      this.subscriptions.pop()?.unsubscribe();
    }
  }

  get size(): number {
    return this.subscriptions.length;
  }
}
